export default function traslateType(type: string) {

    switch (type) {
        case 'grass'://Done
            return 'Grama'
        case 'fire'://Done
            return 'Fogo'
        case 'water'://Done
            return 'Água'
        case 'normal'://done
            return 'Normal'
        case 'rock'://Done
            return 'Pedra'
        case 'ghost'://Done
            return 'Fantasma'
        case 'fighting'://Done
            return 'Lutador'
        case 'steel'://Done
            return 'Aço'
        case 'flying'://Done
            return 'Voador'
        case 'poison'://Done
            return 'Veneno'
        case 'ground'://Done
            return 'Terra'
        case 'psychic'://Done
            return 'Psíquico'
        case 'ice'://done
            return 'Gelo'
        case 'dark'://done
            return 'Escuridão'
        case 'electric'://Done
            return 'Elétrico'
        case 'fairy'://Done
            return 'Fada'
        case 'dragon'://Done
            return 'Dragão'
        case 'bug'://Done
            return 'Inseto'
        case 'shadow'://Done
            return 'Sombra'
        case 'all':
            return 'Todos'
        default:
            return 'N/A'
    }


}
